import { render, staticRenderFns } from "./AmIAlcoholic.vue?vue&type=template&id=27287a82&scoped=true&"
import script from "./AmIAlcoholic.vue?vue&type=script&lang=ts&"
export * from "./AmIAlcoholic.vue?vue&type=script&lang=ts&"
import style0 from "./AmIAlcoholic.vue?vue&type=style&index=0&id=27287a82&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27287a82",
  null
  
)

export default component.exports